import {
  GET_EXCO_KABKOT,
  GET_EXCO_KABKOT_SUCCESS,
  GET_EXCO_KABKOT_FAIL,
} from "./actionTypes";
import { API } from "../../API/api";

export const getTableKabKot = (param,page,search,sort,sortType,filterProv) => (dispatch) => {
  dispatch({
    type: GET_EXCO_KABKOT,
  });

  const request = API.getTableExco(param,page,search,sort,sortType,filterProv);
  return request.then(
    (response) => dispatch(getTableKabKotSuccess(response.data)),
    (err) => dispatch(getTableKabKotFail(err))
  );
};

export const getTableKabKotSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_KABKOT_SUCCESS,
    payload: data,
  });
};

export const getTableKabKotFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_EXCO_KABKOT_FAIL,
    payload: data,
  });
};
